/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { SpaDependencies } from './dependenciesSpaClass.generated';
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated';
import { absDependencies } from './dependenciesAbs.generated';
import { addScalarDependencies } from './dependenciesAddScalar.generated';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { largerDependencies } from './dependenciesLarger.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated';
import { subtractDependencies } from './dependenciesSubtract.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { unaryMinusDependencies } from './dependenciesUnaryMinus.generated';
import { createLup } from '../../factoriesAny.js';
export var lupDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  SpaDependencies: SpaDependencies,
  SparseMatrixDependencies: SparseMatrixDependencies,
  absDependencies: absDependencies,
  addScalarDependencies: addScalarDependencies,
  divideScalarDependencies: divideScalarDependencies,
  equalScalarDependencies: equalScalarDependencies,
  largerDependencies: largerDependencies,
  matrixDependencies: matrixDependencies,
  multiplyScalarDependencies: multiplyScalarDependencies,
  subtractDependencies: subtractDependencies,
  typedDependencies: typedDependencies,
  unaryMinusDependencies: unaryMinusDependencies,
  createLup: createLup
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLup.generated.js
// module id = 321
// module chunks = 0